var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "viq-section-stream" }, [
    _c("h3", { staticClass: "viq-section-stream__title" }, [
      _vm._v("Generating Report"),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "viq-section-stream__sections" },
      _vm._l(_vm.sections, function (section, i) {
        return _c(
          "div",
          {
            key: i,
            staticClass: "viq-section-stream__section",
            class: "viq-section-stream__section--" + section.status,
          },
          [
            _c("div", { staticClass: "viq-section-stream__section-header" }, [
              _c(
                "span",
                { staticClass: "viq-section-stream__section-status" },
                [
                  section.status === "complete"
                    ? _c(
                        "svg",
                        {
                          attrs: {
                            width: "14",
                            height: "14",
                            viewBox: "0 0 14 14",
                            fill: "none",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M3 7l3 3 5-5",
                              stroke: "currentColor",
                              "stroke-width": "1.5",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          }),
                        ]
                      )
                    : section.status === "streaming"
                    ? _c("span", { staticClass: "viq-section-stream__spinner" })
                    : _c("span", {
                        staticClass: "viq-section-stream__pending",
                      }),
                ]
              ),
              _vm._v(" "),
              _c("h4", { staticClass: "viq-section-stream__section-title" }, [
                _vm._v(_vm._s(section.title)),
              ]),
            ]),
            _vm._v(" "),
            section.content
              ? _c("div", {
                  staticClass: "viq-section-stream__section-content",
                  domProps: {
                    innerHTML: _vm._s(_vm.renderContent(section.content)),
                  },
                })
              : _vm._e(),
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _vm.isStreaming
      ? _c(
          "div",
          { staticClass: "viq-section-stream__progress" },
          [
            _c("el-progress", {
              attrs: {
                percentage: _vm.progressPercent,
                "stroke-width": 4,
                color: "#2563eb",
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }